var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bg",rawName:"v-bg",value:({image: _vm.category.background, alternative: true, dir: 'to right'}),expression:"{image: category.background, alternative: true, dir: 'to right'}"}],class:_vm.$store.getters.platform === 'browser' ? 'page-bg-browser' : 'page-bg'},[(_vm.loading)?_c('app-loader'):_c('div',[_c('div',{staticClass:"valign-wrapper wrapper-list",staticStyle:{"overflow":"hidden"}},[_c('app-list',{attrs:{"options":{
            id: 'cat-' + _vm.category.id,
            type: _vm.listType,
            title: _vm.category.name,
            items: _vm.items,
            route: _vm.listRoute,
            card: _vm.category.card,
            wrapper: _vm.$el
          }}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e245876","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/products/ProductCategory.vue
// module id = null
// module chunks = 